
import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { TeamMemberData } from "../types";

export const usePerformanceBandsSupervisorSync = (
  teamMembersData: TeamMemberData[], 
  currentUser: any,
  activeYear: string
) => {
  useEffect(() => {
    const syncSupervisorInfo = async () => {
      if (!currentUser || !teamMembersData || teamMembersData.length === 0) {
        console.log('usePerformanceBandsSupervisorSync: No sync needed - missing data');
        return;
      }

      try {
        console.log('usePerformanceBandsSupervisorSync: Starting supervisor sync for', teamMembersData.length, 'team members');

        // CRITICAL: Only update supervisor information, NEVER touch the status field
        const updatePromises = teamMembersData.map(async (member) => {
          console.log(`usePerformanceBandsSupervisorSync: Syncing supervisor info for ${member.full_name}`);

          // Only update supervisor information, preserve all other fields including status
          const { error } = await supabase
            .from('performance_bands')
            .update({
              supervisor_name: currentUser.full_name,
              team_member_name: member.full_name,
              updated_at: new Date().toISOString()
              // CRITICAL: Do NOT include status in the update to preserve existing values
            })
            .eq('employee_id', member.id)
            .eq('year', activeYear);

          if (error) {
            console.error(`usePerformanceBandsSupervisorSync: Error syncing supervisor info for ${member.full_name}:`, error);
          } else {
            console.log(`usePerformanceBandsSupervisorSync: Successfully synced supervisor info for ${member.full_name}`);
          }
        });

        await Promise.all(updatePromises);
        console.log('usePerformanceBandsSupervisorSync: Supervisor sync completed');

      } catch (error) {
        console.error('usePerformanceBandsSupervisorSync: Error in supervisor sync:', error);
      }
    };

    // Only run sync if we have team members data and current user
    if (teamMembersData.length > 0 && currentUser) {
      syncSupervisorInfo();
    }
  }, [teamMembersData, currentUser, activeYear]);
};
